<template>
  <div class="kw_avatar">
    <div v-for="(item,index) in userArr" :key="'kw_avatar_'+index">
      <div :style="initFieldInfo.styleSet.listFieldTeacherStyleSet?initFieldInfo.styleSet.listFieldTeacherStyleSet.styleSetCode:''" kwName="listFieldTeacherStyleSet">
        <el-avatar v-if="item.BG_FILE" :src="GLOBAL.getFileServeUrl()+item.BG_FILE" :style="initFieldInfo.styleSet.listFieldPhotoSrcPhotoStyleSet?initFieldInfo.styleSet.listFieldPhotoSrcPhotoStyleSet.styleSetCode:''" kwName="listFieldPhotoSrcPhotoStyleSet"></el-avatar>
		    <span v-if="item.NAME" :class="item.BG_FILE?'listuserName1':'listuserName'" :style="item.BG_FILE?(initFieldInfo.styleSet.listFieldPhotoSrcStyleSet?initFieldInfo.styleSet.listFieldPhotoSrcStyleSet.styleSetCode:''):(initFieldInfo.styleSet.listFieldNoPhotoSrcStyleSet?initFieldInfo.styleSet.listFieldNoPhotoSrcStyleSet.styleSetCode:'')" :kwName="item.BG_FILE?'listFieldPhotoSrcStyleSet':'listFieldNoPhotoSrcStyleSet'">{{item.NAME}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kw_avatar',
  props: {
    // 列表调用此组件时 传递的列表数据信息
    initDataInfo: {
      type: Object,
      value: null
    },
    // 列表调用此组件时 列表的页面设置信息
    initpageSetInfo: {
      type: Object,
      value: null
    },
    // 列表调用此组件时 当前字段的信息
    initFieldInfo:{
      type: Object,
      value: null
    },
    // 查看页面 调用时 传递弹出层或加号展开字段的信息
    lookFieldInfo:{
      type: Object,
      value: null
    }
  },
  data() {
    return {
      userArr:[]
    };
  },
  created() {
    var that = this;
    var userArr = [];
    if (that.lookFieldInfo) {
      var lookFieldInfo = that.lookFieldInfo;
      var dialogTableId = lookFieldInfo.dialogTableId;
      if (lookFieldInfo.childPageJsonArr) {
        var userJson = {};
        lookFieldInfo.childPageJsonArr.forEach((one, index) => {
          userJson.ID = one.dataInfo["T_" + dialogTableId + "_0"];
          userJson.NAME = one.dataInfo["F_" + dialogTableId + "_USER_NAME"];
          userJson.BG_FILE = one.dataInfo["F_" + dialogTableId + "_BG_FILE"];
        });
        if(!userJson.NAME) {
            userJson.NAME = "无"
          }
        userArr.push(userJson);
      }
    } 
    var initDataInfo = that.initDataInfo;
    var initFieldInfo = that.initFieldInfo;
    if (initFieldInfo && userArr.length == 0) {
      var fieldAliasName = initFieldInfo.fieldAliasName;
      var userIdStr = initDataInfo[fieldAliasName + '_ID'];
      var userNameStr = initDataInfo[fieldAliasName];
      var userFileStr = initDataInfo[fieldAliasName + '_BG_FILE'];
      console.log("userIdStr===============", userIdStr, userNameStr);
      if (!userFileStr) {
        userFileStr = "";
      }
      if (typeof(userNameStr) == "string") {
        var userIdArr = [];
        var userNameArr = userNameStr.split(",");
        var userFileArr = userFileStr.split(",");
        if (userNameArr.length > 0) {
          if (userIdStr!=null && userIdStr!=undefined) {
            userIdArr = (userIdStr+"").split(",");
          }
          var userJson = {};
          userNameArr.forEach((one, index) => {
            if (userIdArr.length > index) {
              userJson.ID = userIdArr[index];
            }
            if (userFileArr.length > index) {
              userJson.BG_FILE = userFileArr[index];
            }
            userJson.NAME = userNameArr[index];
          });
          if(!userJson.NAME) {
            userJson.NAME = "名师"
          }
          userArr.push(userJson);
        }
      } else {
        var userJson = {};
        userJson.NAME = "名师"
        userArr.push(userJson);
      }
    }

    that.userArr = userArr;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .listuserName{color:#F76921;padding:2.5px 10px;background:#F3F1F2;margin:5px 10px 15px 0;font-size: 14px;display: inline-block}
 .listuserName1{color:#333333;padding:5rpx 20rpx;margin:10rpx 20rpx 30rpx 0;font-size: 14px;display: inline-block}
</style>
